import { makeStyles } from '@mui/styles';
import BackgroundGif from '../assets/woods.gif';
import BackgroundImg from '../assets/cali.jpg';

const useAppStyle = makeStyles({
  root: {
    width: '100vw',
    minHeight: '100%',
    backgroundImage: `url(${BackgroundGif})`,
    backgroundAttachment: 'fixed',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '25% 75%',
  },
  rootMobile: {
    backgroundPosition: 'right',
  },
  rootDark: {
    color: 'white',
  },
  otherPage: {
    backgroundImage: `url(${BackgroundImg})`,
    display: 'flex',
  },
  otherPageDark: {
    color: 'white',
  },
  layer: {
    backgroundColor: 'rgba(255,255,255,0.5)',
    position: 'fixed',
    width: '100vw',
    minHeight: '100%',
  },
  layerDark: {
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  otherPageLayer: {
    backgroundColor: 'rgba(255,255,255,0.7)',
  },
  otherPageLayerDark: {
    backgroundColor: 'rgba(0,0,0,0.7)',
  },
  pageContainer: {
    width: '50%',
    margin: 'auto',
    paddingTop: 20,
    minHeight: '100%',
  },
  pageContainerMobile: {
    width: '80%',
  },
});

export default useAppStyle;
